import React, { PropsWithChildren, useContext } from "react";
import { TabPanel, useTabs } from "react-headless-tabs";
import { PanelGroupContext } from ".";

export interface ITabPaneProps {
  tabKey: string;
}
export const TabPane: React.FC<PropsWithChildren<ITabPaneProps>> = ({
  tabKey,
  children,
}) => {
  const { activeKey } = useContext(PanelGroupContext);

  return <TabPanel hidden={activeKey != tabKey}>{children}</TabPanel>;
};
